import { default as PrevPointCopy } from "./PrevPointCopy"
import { default as PrevPointTitle } from "./PrevPointTitle"
import { default as PrevPointHeading } from "./PrevPointHeading"

export { PrevPointCopy, PrevPointTitle, PrevPointHeading }
